// extracted by mini-css-extract-plugin
module.exports = {"auth0CallBackSpinner":"Auth0Callback_auth0CallBackSpinner_19_RX"};